

export const setUser = (user) => {
 
  localStorage.setItem('userData', JSON.stringify(user));

  return {
    type: 'SET_USER',
    payload: user,
  };
};




export const setClaimId  = (claimId) => {
  console.log("ReduxClaimID>>>" ,claimId);
  
  return {
      type: 'SET_ID',
      payload: claimId,
      
  };
};

  
  export const setBaseUrl = (baseUrl) => ({
    type: 'SET_BASE_URL',
    payload: baseUrl,
  });
  



  
export const setAuthToken = (token) => {
  localStorage.setItem('sAuthToken', token);

  return {
    type: 'SET_AUTHTOKEN',
    payload: token,
  };
};





export const setDemoGraphyData  = (demoDetails) => {

  

  return {
      type: 'SET_DEMODATA',
      payload: demoDetails,
      
  };
};




export const ClearDemoGraphyData  = (demoDetails) => {

  

  return {
      type: 'SET_DEMODATA',
      payload: demoDetails,
      
  };
};






export const claimTableDetails  = (filterTableDetails) => {

  

  return {
      type: 'SET_FILTERED_TABLE_DETAILS',
      payload: filterTableDetails,
      
  };
};




export const RejectedClaim  = (rejectedClaim) => {

 

  return {
      type: 'SET_REJECTED_TABLE',
      payload: rejectedClaim ,
      
  };
};




export const DeniedClaim  = (deniedClaim) => {

  return {
      type: 'SET_DENIED_TABLE',
      payload: deniedClaim ,
      
  };
};




export const ExpiredClaim  = (expiredClaim) => {

  return {
      type: 'SET_EXPIRED_TABLE',
      payload: expiredClaim ,
      
  };
};




export const ErrorClaim  = (errorClaim) => {

  return {
      type: 'SET_ERROR_TABLE',
      payload: errorClaim ,
      
  };
};





export const ClosedClaim  = (closedClaim) => {

  return {
      type: 'SET_CLOSED_TABLE',
      payload: closedClaim ,
      
  };
};





export const SubmissionClaim  = (submissionClaim) => {

  return {
      type: 'SET_SUBMISSION_TABLE',
      payload: submissionClaim ,
      
  };
};




